import { graphql, fetchQuery, Environment } from 'react-relay';
import { Dispatch } from 'redux';

import { SHOW_SHOP_LOCAL_TOAST } from './shopLocalConstants';
import { hasRecentlyDismissedShopLocalPrompt } from './shopLocalHelpers';

import {
    shopLocalConfigQuery,
    shopLocalConfigQueryResponse,
} from './__generated__/shopLocalConfigQuery.graphql';

const shouldShowShopLocal = async ({
    relayEnvironment,
}: {
    relayEnvironment: Environment;
}): Promise<boolean> => {
    if (hasRecentlyDismissedShopLocalPrompt()) {
        return Promise.resolve(false);
    }

    const response: shopLocalConfigQueryResponse = await fetchQuery<shopLocalConfigQuery>(
        relayEnvironment,
        graphql`
            query shopLocalConfigQuery {
                viewer {
                    shopLocalNotificationFeatureFlag: featureFlag(feature: "shopLocalNotification")
                }
            }
        `,
        {}
    );

    return Boolean(response.viewer.shopLocalNotificationFeatureFlag);
};

export const shopLocalConfig = {
    name: 'shopLocal',
    rule: shouldShowShopLocal,
    action: () => (dispatch: Dispatch) => {
        dispatch({
            type: SHOW_SHOP_LOCAL_TOAST,
        });
    },
    priority: 50,
};
